import { Panel as PanelComponent } from "src/components/Panel/Panel.tsx";
import { EmptyState } from "src/components/EmptyState/EmptyState.tsx";
import React from "react";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";

// todo: automatically reset all error boundary on form refresh
export const FormPanelFallback = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary: () => void;
}) => {
  return (
    <PanelComponent>
      <PanelComponent.Header />
      <PanelComponent.Content>
        <EmptyState
          type={"warning"}
          title={"Something went wrong in this panel"}
          description={"Try refreshing the form and then click the reset error"}
          action={
            <ButtonV2 skin={"info"} size={"sm"} onClick={resetErrorBoundary}>
              Reset
            </ButtonV2>
            // todo: should I add refresh button here?
          }
        />
      </PanelComponent.Content>
    </PanelComponent>
  );
};
